/* Hero */
.hero {
  padding-block: clamp(40px, 7vw, 80px) clamp(40px, 6vw, 68px);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: clamp(34px, 5vw, 60px);
  align-items: center;
}

.heroText {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.eyebrow {
  font-size: 12px;
  color: var(--ink-muted);
  letter-spacing: 1.8px;
  text-transform: uppercase;
}

.title {
  font-size: clamp(38px, 5.6vw, 60px);
  line-height: 1.06;
  color: var(--ink);
}

.sub {
  font-size: clamp(17px, 2vw, 19px);
  line-height: 1.6;
  color: var(--ink-muted);
  max-width: 42ch;
}

.leads {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 11px;
}

.lead {
  display: grid;
  grid-template-columns: 9px 1fr;
  gap: 14px;
  align-items: baseline;
  font-size: 16px;
  line-height: 1.5;
  color: var(--ink);
}

.bullet {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--ink);
  display: block;
}

/* Section furniture, shared by Features and About */
.sectionTitle {
  font-size: clamp(30px, 4vw, 42px);
  line-height: 1.1;
  color: var(--ink);
}

.sectionLead {
  font-size: 17px;
  line-height: 1.6;
  color: var(--ink-muted);
}

/* Features */
.features {
  background: var(--paper-band);
  border-block: 1px solid var(--rule);
}

.featuresInner {
  padding-block: clamp(48px, 6vw, 76px);
  display: flex;
  flex-direction: column;
  gap: clamp(26px, 4vw, 40px);
}

.sectionHead {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 50ch;
}

.featureGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
  column-gap: clamp(28px, 4vw, 56px);
}

.feature {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-block: 22px;
  border-top: 1px solid var(--rule);
}

.featureTitle {
  font-size: 22px;
  color: var(--ink);
}

.featureBody {
  font-size: 15px;
  line-height: 1.6;
  color: var(--ink-muted);
}

/* About */
.about {
  padding-block: clamp(48px, 6vw, 76px);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: clamp(28px, 5vw, 56px);
  align-items: start;
}

.aboutHead {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.aboutHead .sectionLead {
  line-height: 1.65;
}

.aboutList {
  display: flex;
  flex-direction: column;
}

.aboutItem {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-block: 18px;
  border-top: 1px solid var(--rule);
}

.aboutItemTitle {
  font-size: 20px;
  color: var(--ink);
}
